const Video = () => {
  return <h1>Video</h1>;
};

export default Video;
